export default {
  programs: [],
  memberships: [],
  programRevenues: [],
  pauses: [],
  notes: [],
  programRevenueTotal: {
    count: 0,
    revenue: 0,
  },
  selectedProgram: null,
  selectedMembership: null,
}
